export default {
  formId: 'kotaKabForm',
  formField: {
    kode: {
      name: 'kode',
      label: 'Kode*',
      requiredErrorMsg: 'Kode harus diisi'
    },
    nama: {
      name: 'nama',
      label: 'Nama*',
      requiredErrorMsg: 'Nama harus diisi'
    }
  }
};
